<template>
  <div align="center">
    <h3 align="center" class="wizard-title" style="color: green; width: 70%; margin-top:40px;">
      Thanks for registering with GlobeChek
    </h3>
    <br />
    <h5 align="center" style="width: 70%;">
      You have completed the preliminary registration. We will send a confirmation and login instructions to your email.
    </h5>
    <h5 align="center" style="width: 70%;">
      If you do not receive notification from GlobeChek within 2 days, please contact us at
      <a href="mailto:info@globechek.com">Info@GlobeChek.com</a>
    </h5>
  </div>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions"
export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      //
    }
  },
  watch: {},
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res)
        return res
      })
    }
  }
}
</script>
<style></style>
